
import {Table} from '@burna/monster-design-system';
import {Link} from 'react-router-dom';
import CopyIcon from 'components/copy-icon';
import styles from './index.module.scss';

function SettingsTable({urlList}) {
  if (!urlList.length === 0) {
    return null;
  }

  return (
    <>
      <h3 className={styles.heading}>All file URLs with their Settings</h3>
      <div className={styles.table}>
        <Table
          rowsPerPage={7}
          columnDefinitions={[
            {type: 'text', header: '#'},
            {type: 'badge', size: 'lg', header: 'One-Time Download'},
            {type: 'badge', size: 'lg', header: 'Password'},
            {type: 'text', header: 'Expiration Time'},
            {type: 'action-icons', header: 'URL'},
          ]}
        >
          {urlList.map((item, i) => (
            <Table.Row key={i}>
              <Table.Cell>
                {i + 1}
              </Table.Cell>
              <Table.Cell
                type={item.oneTimeDownload ? 'success' : 'gray'}
                icon={item.oneTimeDownload ? 'check' : 'x'}
              />
              <Table.Cell
                type={item.password ? 'success' : 'gray'}
                icon={item.password ? 'lock' : 'x'}
              />
              <Table.Cell>
                {item.expiration ? new Date(item.expiration).toLocaleString() : 'Not Set'}
              </Table.Cell>
              <Table.Cell>
                <Table.ActionIcon icon="download" as={Link} to={item.url} target="_blank" />
                <CopyIcon value={(window.origin + item.url).replace(/(?!^) (?!$)/g, '%20')} />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table>
      </div>
    </>
  );
}

export default SettingsTable;
